/* eslint-disable radix */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
/* eslint-disable no-shadow */
/* eslint-disable camelcase */
import {
  Box,
  Button,
  CircularProgress,
  Container,
  OutlinedInput,
  Paper,
  Typography,
} from '@material-ui/core'
import icons from '@assets/icons'
import React, {
  Fragment, useEffect, useMemo, useState,
} from 'react'
import { useForm } from 'react-hook-form'
import { Link, useHistory } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { useSnackbar } from 'notistack'
import { resellerApi, resellerApiWithToken } from '@api/baseApi'
import FieldPackageChooser from '@components/CustomFields/FieldPackageChooser'
import application from '@config/application'
import RadioPaymentChannels from '@components/CustomFields/RadioPaymentChannels'
import useAxios from '@hooks/useAxios'
import getDomain from '@config/domain'
import Cookies from 'js-cookie'
import SelecFromApi from '@components/CustomFields/SelectFromApi'
import RupiasFormat from '@components/RupiasFormat'
import useQuery from '@hooks/useQuery'
// import { matchDomain } from '@config/helpers'
import useStyles from './styles-jss/register-jss'
import FormRegister from './FormRegister'
import hookFormConfig from './hookFormConfig'
import LoginDialog from './LoginDialog'

const Register = () => {
  const classes = useStyles()
  // eslint-disable-next-line no-unused-vars
  const query = useQuery()
  const ref = localStorage.getItem('ref')

  const {
    errors,
    control,
    handleSubmit,
    getValues,
    setValue,
    register,
    reset,
    watch,
  } = useForm(hookFormConfig)

  const hookFormProps = {
    errors,
    control,
    getValues,
    setValue,
    register,
    watch,
  }

  const [isSubmitting, setSubmitting] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const history = useHistory()
  const [open, setOpen] = useState(false)
  const [isUseExistingAcc, setIsUseExistingAcc] = useState(false)
  const [referralValue, setReferralValue] = useState('')
  const [referral, setReferral] = useState(null)
  const [loading, setLoading] = useState(false)
  const [availableAccountData, setAvailableAccountData] = useState(null)
  const paymentChannels = useAxios(
    resellerApi,
    'get',
    '/api/v1/resellers/payment_methods',
  )
  const couriers = useAxios(
    resellerApi,
    'get',
    '/api/v1/resellers/couriers/stores',
  )
  const [summary, setSummary] = useState(null)
  const [loadSummary, setLoadSummary] = useState(false)
  const [selectedPackage, setSelectedPackage] = useState()
  const [courierPackages, setCourierPackages] = useState([])

  const selectedCourierService = useMemo(() => {
    let selected
    if (summary) {
      selected = { service: summary?.selected_courier_package?.service }
      setValue('courier_service', selected)
    }

    return selected
  }, [summary])

  const courierServices = useMemo(() => {
    const data = []
    if (summary) {
      summary?.courier?.courier_packages?.map((item) => data.push({ service: item.service }))
    }

    return data
  }, [summary?.courier?.courier_packages])

  useEffect(() => {
    if (summary) {
      const selected = { service: summary?.selected_courier_package?.service }
      setValue('courier_service', selected)
    }
  }, [summary])

  useEffect(() => {
    if (query.get('ref')) localStorage.setItem('ref', query.get('ref'))
  }, [query.get('ref')])
  const customerType = watch('customer_type_id')

  const checkReferralCode = async () => {
    if (referralValue === '' && !ref) {
      enqueueSnackbar('Silahkan isi kode referral Anda', {
        variant: 'warning',
      })
    } else {
      const params = {
        domain: getDomain(),
        referral_code: watch('referral_code') || ref,
        customer_type_id: customerType,
      }

      try {
        setLoading(true)
        const res = await resellerApiWithToken.get(
          '/resellers/customer_types/check_referral',
          { params },
        )
        if (res.status === 200) {
          setLoading(false)
          setReferral({ ...res?.data?.data, result: 'found' })
          setReferralValue(params?.referral_code)
        } else {
          setReferralValue()
          setLoading(false)
          setReferral({ result: res?.response?.data?.data })
          if (ref) {
            localStorage.removeItem('ref')
            history.push(`${application.prefix}/login`)
          }
        }
      } catch (error) {
        setLoading(false)
      }
    }
  }

  useEffect(() => {
    if (ref) {
      checkReferralCode()
    }
  }, [ref])

  useEffect(() => {
    couriers.fetch({ params: { domain: getDomain() } })
    paymentChannels.fetch({ params: { domain: getDomain() } })
  }, [])

  const courier = watch('courier')
  const district = watch('district')
  const courierService = watch('courier_service')

  const generateSummary = async () => {
    setCourierPackages(null)
    const params = {
      registration: {
        customer_type_id: `${selectedPackage?.id}`,
        courier: courier?.code,
        district_id: district?.id,
      },
    }
    try {
      setSummary(null)
      setLoadSummary(true)
      setCourierPackages(null)
      const {
        status,
        data: { data },
      } = await resellerApi.post(
        '/api/v1/resellers/customer_types/shipping_cost',
        params,
      )
      if (status === 200) {
        setSummary(data)
        setCourierPackages(data?.courier?.courier_packages)
        setLoadSummary(false)
      }
    } catch (error) {
      setLoadSummary(false)
    }
  }

  useEffect(() => {
    if (
      courier
      && district
      && selectedPackage
      && selectedPackage.fee_items.length > 0
    ) {
      generateSummary()
    }
  }, [courier, district, selectedPackage, selectedPackage?.fee_items?.length])

  const onReferralChange = async (e) => {
    const { value } = e.target
    setValue('referral_code', value, { shouldValidate: value })
    setReferralValue(value)
  }

  const renderReferralResult = () => {
    const style = {
      alignSelf: 'flex-start',
      marginLeft: 30,
    }

    if (referral) {
      if (referral.result === 'found') {
        return (
          <Typography variant="body1" color="secondary" style={style}>
            {referral.name}
          </Typography>
        )
      }
      return (
        <Typography variant="body1" color="error" style={style}>
          {referral.result}
        </Typography>
      )
    }
  }

  const payment = watch('price') !== '' && watch('price') !== '0'

  const handleLoginAvailableAccount = async (data, formValue) => {
    await Cookies.set('reseller_app_token', data.access_token)
    await localStorage.setItem('payload', JSON.stringify(data.data))

    const params = {
      referral_code: formValue.referral_code,
      domain: getDomain(),
      customer_id: data.data.customer_id,
      payment_channel: formValue.payment_method,
      customer_type_id: formValue.customer_type_id,
    }

    const { price } = formValue

    try {
      const {
        status,
        data: { data },
      } = await resellerApi.post('/api/v1/registration_other_stores', {
        registration: params,
      })

      if (status === 200) {
        setSubmitting(false)
        if (price === '0' || price === 0) {
          enqueueSnackbar('Pendaftaran berhasil', {
            variant: 'success',
          })
          history.push(`${application.prefix}/login`)
        } else {
          const normalizeBank = Array.isArray(data.available_banks)
            ? data.available_banks
            : [data.available_banks]
          history.push({
            pathname: `${application.prefix}/payments`,
            state: {
              banks: normalizeBank,
              ewallets: data?.available_ewallets,
              outlets: data?.available_retail_outlets,
              price: data?.formated_total,
              paymentUrl: data?.payment_url,
              withAvailableAccount: formValue.provider,
            },
          })
        }
      } else if (Array.isArray(data)) {
        data.map((value) => enqueueSnackbar(value, {
          variant: 'error',
        }))
      }
    } catch (error) {
      setSubmitting(false)
      if (Array.isArray(error?.response?.data?.data)) {
        error?.response?.data?.data?.map((value) => enqueueSnackbar(value, {
          variant: 'error',
        }))
      } else {
        enqueueSnackbar('Maaf, Terjadi kesalahan pada sistem', {
          variant: 'error',
        })
      }
    }
  }

  const selectedCourierPackage = useMemo(() => {
    if (courierService && courierPackages?.length > 0) {
      const selectedService = courierPackages?.find(
        (e) => e.service === courierService.service,
      )
      return selectedService
    }
    return null
  }, [courierService, courierPackages, courierService?.service])

  const onSubmit = async (data) => {
    // const { payment_method } = data

    if (
      selectedPackage
      && selectedPackage.fee_items.length > 0
      && !courier
      && courierService === undefined
    ) {
      return enqueueSnackbar(
        'Silahkan pilih kurir dan jenis layanan terlebih dahulu',
        { variant: 'warning' },
      )
    }

    const { price } = data

    if (data.provider === 'available_account') {
      return handleLoginAvailableAccount(availableAccountData, data)
    }

    const newParams = {
      name: data.name,
      email: data.email,
      phone: data.phone,
      password: data.password,
      courier_service: data?.courier_service?.service,
      password_confirmation: data.password_confirmation,
      address: data.address,
      customer_type_id: data.customer_type_id,
      district_id: data.district?.id,
      domain: getDomain(),
      referral_code: data.referral_code,
      payment_method: data.payment_method,
      courier: courier && courier.code,
    }

    try {
      setSubmitting(true)
      const res = await resellerApi.post('api/v1/users', newParams)
      const {
        status,
        data: { data },
      } = res

      if (status === 200) {
        setSubmitting(false)
        if (price === '0' || price === 0) {
          enqueueSnackbar('Pendaftaran berhasil', {
            variant: 'success',
          })
          history.push(`${application.prefix}/login`)
          localStorage.removeItem('ref')
        } else {
          localStorage.removeItem('ref')
          history.push({
            pathname: `${application.prefix}/register-payment`,
            state: {
              banks: data.available_banks || [],
              ewallets: data?.available_ewallets,
              outlets: data?.available_retail_outlets,
              price: data?.formated_total_uniq_code,
              paymentUrl: data?.payment_url,
              customer_id: data?.customer_id,
              registration_payment_id: data?.registration_payment_id,
            },
          })
        }
      } else {
        setSubmitting(false)
        // eslint-disable-next-line no-shadow
        const {
          data: { data },
        } = res
        if (data.message) {
          enqueueSnackbar(data.message, {
            variant: 'error',
          })
        } else if (Array.isArray(data)) {
          data.map((value) => enqueueSnackbar(value, {
            variant: 'error',
          }))
        }
      }
    } catch (error) {
      setSubmitting(false)
      if (error.response?.data?.data?.message) {
        enqueueSnackbar(error.response?.data?.data?.message, {
          variant: 'error',
        })
      } else if (Array.isArray(error?.response?.data?.data)) {
        error?.response?.data?.data?.map((value) => enqueueSnackbar(value, {
          variant: 'error',
        }))
      } else if (error.response?.data?.data) {
        enqueueSnackbar(error.response?.data?.data, {
          variant: 'error',
        })
      } else {
        enqueueSnackbar('Maaf, Terjadi kesalahan pada sistem', {
          variant: 'error',
        })
      }
    }
  }

  return (
    <Fragment>
      <Helmet>
        <title>{window.location.host} | Register</title>
      </Helmet>
      <form
        onSubmit={handleSubmit(onSubmit)}
        autoComplete="off"
        className={classes.root}
      >
        <Box className={classes.background}>
          {/* {
          matchDomain(window.location.hostname)
          && (
          <img
            src={icons.AppLogoWhite}
            height={138}
            width={110}
            alt="logo"
            className={classes.logo}
          />
          )
        } */}
          <div style={{ width: 110, height: 138 }} />
        </Box>
        <Box className={classes.content}>
          <Box className={classes.column}>
            <FormRegister
              handleSubmit={handleSubmit}
              isSubmitting={isSubmitting}
              setSubmitting={setSubmitting}
              setOpen={setOpen}
              setIsUseExistingAcc={setIsUseExistingAcc}
              isUseExistingAcc={isUseExistingAcc}
              setFormValue={setValue}
              reset={reset}
              availableAccountData={availableAccountData}
              {...hookFormProps}
            />
          </Box>
          <Box className={classes.column}>
            <input
              type="text"
              value={referralValue}
              ref={register}
              name="referral_code"
              hidden
            />
            {ref && referral?.result !== 'not_found' ? (
              <Box
                display="flex"
                justifyContent="flex-start"
                width="100%"
                paddingLeft={6}
                marginTop={2}
                flexDirection="column"
              >
                <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                  Kode Referral
                </Typography>
                <Typography
                  variant="h6"
                  color="primary"
                  style={{
                    fontWeight: 'bold',
                  }}
                >
                  {ref}
                </Typography>
              </Box>
            ) : (
              <Fragment>
                <div className={classes.referralCode}>
                  <div className={classes.inputReferralWrapper}>
                    <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                      Kode Referral
                    </Typography>
                    <OutlinedInput
                      name="referal"
                      className={classes.inputReferral}
                      value={referralValue}
                      onChange={onReferralChange}
                      readOnly={ref}
                      onBlur={() => setReferral()}
                      endAdornment={
                        referral?.result === 'found' && (
                          <img src={icons.ChecklistCircle} alt="checklist" />
                        )
                      }
                    />
                  </div>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.btnReferral}
                    onClick={checkReferralCode}
                    disabled={ref}
                  >
                    {loading ? (
                      <CircularProgress size={24} color="secondary" />
                    ) : (
                      'Cek Kode'
                    )}
                  </Button>
                </div>
                {renderReferralResult()}
              </Fragment>
            )}
            {paymentChannels?.data ? (
              <FieldPackageChooser
                register={register}
                setValue={setValue}
                errors={errors}
                referralCode={referralValue}
                getSelectedPackage={(value) => setSelectedPackage(value)}
              />
            ) : (
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                marginTop={8}
              >
                <CircularProgress size={24} />
                <Typography>Memuat data...</Typography>
              </Box>
            )}
            {watch('price') === '0' && (
              <input
                type="text"
                ref={register}
                name="payment_method"
                defaultValue="FREE"
                hidden
              />
            )}
            {payment
              && selectedPackage
              && selectedPackage.fee_items.length > 0 && (
                <Container>
                  <SelecFromApi
                    name="courier"
                    label="Kurir"
                    getSelectedOption={(value, option) => value.id === option.id}
                    getOptionLabel={(value) => value.name}
                    options={couriers.data || []}
                    required
                    {...hookFormProps}
                  />
                  {summary && (
                    <SelecFromApi
                      name="courier_service"
                      label="Layanan"
                      getSelectedOption={(value, option) => value.service === option.service}
                      getOptionLabel={(value) => value.service}
                      options={courierServices}
                      defaultValue={selectedCourierService}
                      required
                      {...hookFormProps}
                    />
                  )}
                  {loadSummary && (
                    <Typography>Mengecek ongkos kirim...</Typography>
                  )}
                  {summary && Object.keys(summary).length > 0 && (
                    <table style={{ width: '100%' }}>
                      <tr>
                        <th style={{ textAlign: 'left' }}>
                          <Typography className={classes.txSummary}>
                            Ongkos Kirim
                          </Typography>
                        </th>
                        <th style={{ textAlign: 'right' }}>
                          <Typography className={classes.txPrice}>
                            {summary ? (
                              <RupiasFormat
                                value={selectedCourierPackage?.value}
                                displayType="text"
                              />
                            ) : (
                              'Rp. 0'
                            )}
                          </Typography>
                        </th>
                      </tr>
                      <tr>
                        <th style={{ textAlign: 'left' }}>
                          <Typography className={classes.txSummary}>
                            Total
                          </Typography>
                        </th>
                        <th style={{ textAlign: 'right' }}>
                          <Typography className={classes.txPrice}>
                            {summary ? (
                              <RupiasFormat
                                value={
                                  parseInt(
                                    selectedCourierPackage?.value
                                      || 0,
                                  ) + parseInt(selectedPackage?.total_fee)
                                }
                                displayType="text"
                              />
                            ) : (
                              'Rp. 0'
                            )}
                          </Typography>
                        </th>
                      </tr>
                    </table>
                  )}
                  {summary && Object.keys(summary).length === 0 && (
                    <Typography>
                      Pengiriman ke kota tujuan dengan kurir tersebut tidak
                      tersedia, silahkan coba kurir lain.
                    </Typography>
                  )}
                </Container>
            )}
            {payment && (
              <Container>
                <RadioPaymentChannels
                  items={paymentChannels.data}
                  name="payment_method"
                  label="Metode Pembayaran"
                  errors={errors}
                  disabled={isSubmitting}
                  control={control}
                />
              </Container>
            )}
          </Box>
          <Paper className={classes.footer}>
            <div className={classes.loginLink}>
              <Typography
                variant="subtitle2"
                className={classes.loginLinkLabel}
              >
                Punya akun?
              </Typography>
              <Button
                color="primary"
                component={Link}
                to={`${application.prefix}/`}
              >
                Masuk
              </Button>
            </div>

            <Button
              type="submit"
              className={classes.btnSubmit}
              color="primary"
              variant="contained"
              disabled={
                isSubmitting
                || loadSummary
                || (summary && Object.keys(summary).length === 0)
              }
            >
              {isSubmitting ? (
                <CircularProgress color="secondary" size={24} />
              ) : (
                'Daftar Sekarang'
              )}
            </Button>
          </Paper>
        </Box>
      </form>
      <LoginDialog
        open={open}
        onClose={() => setOpen(false)}
        setFormValue={setValue}
        setIsUseExistingAcc={setIsUseExistingAcc}
        setAvailableAccountData={setAvailableAccountData}
        maxWidth="md"
      />
    </Fragment>
  )
}

export default Register
